import React, {useState} from "react";
import {NavLink, Outlet, useNavigate} from "react-router-dom";
import AdminLogin, {isAdminLoggedIn, adminLogout} from "./AdminLogin";
import "./AdminLayout.css";

const NAV = [
  {to: "/admin", label: "Dashboard", icon: "📊", end: true},
  {to: "/admin/products", label: "Products", icon: "📦"},
  {to: "/admin/categories", label: "Categories", icon: "🗂️"},
  {to: "/admin/orders", label: "Orders", icon: "🛒"},
  {to: "/admin/reviews", label: "Reviews", icon: "⭐"},
  {to: "/admin/coupons", label: "Coupons", icon: "🏷️"},
  // {to: "/admin/videocalls", label: "Video Calls", icon: "📹"},
  {to: "/admin/contacts", label: "Contacts", icon: "📬"},
];

export default function AdminLayout() {
  const [loggedIn, setLoggedIn] = useState(isAdminLoggedIn());
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  // Show login screen if not authenticated
  if (!loggedIn) {
    return <AdminLogin onLogin={() => setLoggedIn(true)} />;
  }

  return (
    <div className={`admin-shell ${collapsed ? "collapsed" : ""}`}>
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          {/* <span className="sidebar-logo">◆</span>
          {!collapsed && <span className="sidebar-brand">NoveltyCo Admin</span>} */}
          {!collapsed ? (
            <img
              src={require("../../assets/logo/logo.png")}
              alt="Variant Exclusive"
              style={{height: 28, width: "auto", objectFit: "contain"}}
            />
          ) : (
            <img
              src={require("../../assets/logo/logo.png")}
              alt="VE"
              style={{height: 24, width: 24, objectFit: "contain"}}
            />
          )}
          <button
            className="collapse-btn"
            onClick={() => setCollapsed((c) => !c)}
          >
            {collapsed ? "→" : "←"}
          </button>
        </div>

        <nav className="sidebar-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({isActive}) =>
                `sidebar-link ${isActive ? "active" : ""}`
              }
            >
              <span className="nav-icon">{item.icon}</span>
              {!collapsed && <span className="nav-label">{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-link" onClick={() => navigate("/")}>
            <span className="nav-icon">🏪</span>
            {!collapsed && <span className="nav-label">View Store</span>}
          </button>
          <button
            className="sidebar-link"
            onClick={adminLogout}
            style={{color: "#ef4444"}}
            title="Logout"
          >
            <span className="nav-icon">🚪</span>
            {!collapsed && <span className="nav-label">Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div className="admin-main">
        <Outlet />
      </div>
    </div>
  );
}
